import { States } from "../../../../../../../common/constants/states";

class AdminStudentCreatePickupLocationResidenceController {
  constructor(
    $rootScope,
    $scope,
    $state,
    $stateParams,
    UsersModel,
    FlashService,
  ) {
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$state = $state;
    this.UsersModel = UsersModel;
    this.FlashService = FlashService;
    this.states = States;

    this.hasPickupLocation = false;
    this.student = {};
    this.student.pickuplocation = {};
    this.submitted = false;

    this.submitPickupLocation = this.submitPickupLocation.bind(this);

    UsersModel.getStudentByID($stateParams.userId).then((response) => {
      this.student = response;
      this.student.pickuplocation = {
        hidden: false,
      };
    });
  }

  submitPickupLocation() {
    this.submitted = true;
    this.UsersModel.addPickupLocation({
      student_id: this.student.id,
      hidden: this.student.pickuplocation.hidden,
      pickuplocation: {
        name: this.student.pickuplocation.name,
        street: this.student.pickuplocation.street,
        city: this.student.pickuplocation.city,
        state: this.student.pickuplocation.state,
        zip: this.student.pickuplocation.zip,
      },
    })
      .then((response) => {
        let type = "success";
        if (
          response.message ===
          "Your pick up location was not in the school's service area. Your pick up location is the driving school."
        ) {
          type = "info";
        }
        this.FlashService.setMessage({
          type: type,
          message: response.message,
        });

        if (type === "info") {
          //dont change state until info alert is closed
          this.$scope.$on("MESSAGE_CLEARED", () => {
            this.submitted = false;
            this.$state.go(
              "drivecoach.admin.students.view.pickuplocations",
              { studentId: this.student.id },
              { reload: true },
            );
          });
        } else {
          this.submitted = false;
          this.$state.go(
            "drivecoach.admin.students.view.pickuplocations",
            { studentId: this.student.id },
            { reload: true },
          );
        }
        //state change doesnt happen until info alert is cleared
      })
      .catch((Error) => {
        this.submitted = false;
      });
  }
}

AdminStudentCreatePickupLocationResidenceController.$inject = [
  "$rootScope",
  "$scope",
  "$state",
  "$stateParams",
  "UsersModel",
  "FlashService",
];
export default AdminStudentCreatePickupLocationResidenceController;

